import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UserService } from '../services/user-service';
import { of } from 'rxjs';

export const authGuard: CanActivateFn = (_route, state) => {
  const userService = inject(UserService);
  if (userService.user.value.name) {
    return of(true);
  }
  return userService.login(state.url);
};
